
export const SEND_MESSAGE = 'send_message'
export const SYMBOL_CHANEL = 'trading_data'
export const CREATE_TRANSACTION = 'new_transaction'
export const UPD_TRANSACTION = 'upd_transaction'
export const UPD_ORDER = 'upd_order'
export const NEW_ORDER = 'new_order'
